import {
  PRODUCTS_LIST,
  PRODUCTS_LIST_SUCCESS,
  PRODUCTS_LIST_ERROR
} from '../contants';
import { Reducer } from 'redux';
import { Product } from '../../models/product/product-response.model';

type ProductInitStateType = {
  products: Product[];
  loading: boolean;
  error: boolean;
  errorMessage: string;
}

const INIT_STATE = {
  products: [],
  loading: false,
  error: false,
  errorMessage: '',
};

const ProductReducer: Reducer<ProductInitStateType> = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case PRODUCTS_LIST:
      return { ...state, loading: true, error: false };
    case PRODUCTS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        products: action.payload,
        error: false,
      };
    case PRODUCTS_LIST_ERROR:
      return {
        ...state,
        loading: false,
        products: [],
        error: true,
        errorMessage: action.payload.message,
      };
    default:
      return { ...state };
  }
};

export default ProductReducer;